<form [formGroup]="form">
  <div class="flex margin-top-15 f-gap--10px" formGroupName="dependenceAxa">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">
          DEPENDENCIA AXA
        </mat-card-title>
        <howden-label-value
          class="f-basis--2 group-result-rmbonus"
          [value]="dependenceAxa.productName || ''">
        </howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-10">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6">
            <div class="flex f-gap--10px">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">
                  Capital dependencia severa
                </mat-label>
                <mat-select
                  formControlName="depAxaSevereDependency"
                  [compareWith]="compareByIdNumber"
                  [howdenControlError]="DEPAxa_DependenciaSeveraError">
                  <mat-option value="0">Selecciona</mat-option>
                  @for (item of (dependenceAxa.getMasterValues('S_DEP_AXA_SEVEREDEPENDENCY') | howdenArraySort:'description'); track item.id) {
                    <mat-option [value]="item.id">{{ item.description }}</mat-option>
                  } @empty {
                    <mat-option disabled>No hay opciones disponibles</mat-option>
                  }
                </mat-select>
                <mat-error #DEPAxa_DependenciaSeveraError></mat-error>
              </mat-form-field>

              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">
                  Gran dependencia
                </mat-label>
                <input
                  matInput
                  type="number"
                  inputmode="decimal"
                  min="0"
                  step="any"
                  formControlName="depAxaGreatDependency"
                  [howdenControlError]="depAxaGreatDependencyError"
                  readonly
                  aria-label="Gran dependencia (calculada automáticamente como severa por 2)"
                  [howdenMax]="9999999" />
                <mat-error #depAxaGreatDependencyError></mat-error>
              </mat-form-field>
            </div>
          </div>

          @if (showTrace()) {
            <div class="f-basis--4">
              <div class="trace-container" [innerHTML]="getTraceHtml(dependenceAxa) || ''"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (dependenceAxa.chargeable) {
              <howden-label-value labelText="Prima" [value]="dependenceAxa.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(dependenceAxa); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }

            @for (m of getMessages(dependenceAxa); track $index) {
              @if (!m.blocking) {
                <br />
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="flex margin-top-15 f-gap--10px" formGroupName="dependenceSurne">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.sane-projects.calculator.label">
          DEPENDENCIA SURNE
        </mat-card-title>
        <howden-label-value
          class="f-basis--2 group-result-rmbonus"
          [value]="dependenceSurne.productName || ''">
        </howden-label-value>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="margin-top-10">
        <div class="flex" style="align-items:flex-start;">
          <div class="f-basis--6">
            <div class="flex f-gap--10px">
              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.Surne_CapitalRentas">
                  Capitales/Renta
                </mat-label>
                <mat-select
                  formControlName="depSurneCapitalIncome"
                  [howdenControlError]="depSurneCapitalIncomeError">
                  <mat-option value="">Selecciona</mat-option>
                  @for (item of (dependenceSurne.getMasterValues('S_DEP_SURNE_CAPITALINCOME') | howdenArraySort:'description'); track item.id) {
                    <mat-option [value]="item.id">{{ item.description }}</mat-option>
                  } @empty {
                    <mat-option disabled>No hay opciones disponibles</mat-option>
                  }
                </mat-select>
                <mat-error #depSurneCapitalIncomeError></mat-error>
              </mat-form-field>

              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">
                  Dependencia severa
                </mat-label>
                <mat-select
                  formControlName="depSurneSevereDependency"
                  [compareWith]="compareByIdNumber"
                  [howdenControlError]="depSurneSevereDependencyError">
                  <mat-option value="">Selecciona</mat-option>
                  @for (item of (dependenceSurne.getMasterValues('S_DEP_SURNE_SEVEREDEPENDENCY') | howdenArraySort:'description'); track item.id) {
                    <mat-option [value]="item.id">{{ item.description }}</mat-option>
                  } @empty {
                    <mat-option disabled>No hay opciones disponibles</mat-option>
                  }
                </mat-select>
                <mat-error #depSurneSevereDependencyError></mat-error>
              </mat-form-field>

              <mat-form-field class="field-inputs">
                <mat-label i18n="@@app.sane-projects.calculator.label">
                  Gran dependencia
                </mat-label>
                <input
                  matInput
                  type="number"
                  inputmode="decimal"
                  min="0"
                  step="any"
                  formControlName="depSurneGreatDependency"
                  [howdenControlError]="depSurneGreatDependencyError"
                  readonly
                  aria-label="Gran dependencia (calculada automáticamente como severa por 2)"
                  [howdenMax]="9999999" />
                <mat-error #depSurneGreatDependencyError></mat-error>
              </mat-form-field>
            </div>
          </div>

          @if (showTrace()) {
            <div class="f-basis--4">
              <div class="trace-container" [innerHTML]="getTraceHtml(dependenceSurne) || ''"></div>
            </div>
          }

          <div class="f-basis--2 group-result-rmbonus">
            @if (dependenceSurne.chargeable) {
              <howden-label-value labelText="Prima" [value]="dependenceSurne.bonus | bonus"></howden-label-value>
              <br />
            } @else {
              @for (m of getMessages(dependenceSurne); track $index) {
                @if (m.blocking) {
                  <howden-label-value labelText="Errores" [innerHTML]="m.html"></howden-label-value>
                }
              }
            }

            @for (m of getMessages(dependenceSurne); track $index) {
              @if (!m.blocking) {
                <br />
                <howden-label-value labelText="Mensajes" [innerHTML]="m.html"></howden-label-value>
              }
            }
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</form>
